export enum DatePickerType {
    FROM = "lastUpdatedFrom",
    TO = "lastUpdatedTo",
}
